export enum SubscriptionColumn {
  TENANT = 'tenant',
}

export const subscriptionColumns = Object.values(SubscriptionColumn) as string[];
